import { ApiErrorDetails } from './api-error-details.interface';

export class ApiError extends Error {
    public statusCode: number;

    public name: string;

    public message: string;
    public detailMessage: string;

    public details?: ApiErrorDetails[];

    constructor(data: {
        detail: string;
        message: string;
        path: string;
        status: number;
        title: string;
        type: string;
        fieldErrors: ApiErrorDetails[];
    }) {
        super(data.message);
        this.statusCode = data.status;
        this.name = data.title;
        this.message = data.message;
        this.detailMessage = data.detail;
        this.details = data.fieldErrors;
    }
}
